module.exports = __webpack_public_path__ + "static/media/logo_1.d6313777.png";